var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWatch = function SvgIconWatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M6 1.886a6.45 6.45 0 0 0-6 4.09 6.45 6.45 0 0 0 6 4.092 6.45 6.45 0 0 0 6-4.091 6.45 6.45 0 0 0-6-4.091m0 6.818a2.728 2.728 0 0 1 0-5.455 2.728 2.728 0 0 1 0 5.455M6 4.34c-.905 0-1.636.731-1.636 1.637 0 .905.73 1.636 1.636 1.636s1.636-.73 1.636-1.636S6.906 4.34 6 4.34"
  })));
};
export default SvgIconWatch;